<div class="p-4">
  @if (id === "new") {
    <h2 class="mb-4" i18n="Create user label">
      {{ "createUser" | transloco }}
    </h2>
  }
  @if (id !== "new") {
    <h2 class="mb-4" i18n="Edit user label">
      {{ "editUser" | transloco }}
    </h2>
  }
  <div>
    @if (id !== "new") {
      <app-user-basic-info-form
        [mode]="'edit'"
        [tenants]="tenantOptions"
        [userGroups]="userGroupsRepository.userGroups$ | async"
        [showPasswordField]="id === 'new'"
        (userSubmit)="onInfoSubmit($event)"
      >
      </app-user-basic-info-form>
    }
    @if (id === "new") {
      <app-user-basic-info-form
        [mode]="'new'"
        [tenants]="tenantOptions"
        [userGroups]="userGroupsRepository.userGroups$ | async"
        [showPasswordField]="id === 'new'"
        (userSubmit)="onInfoSubmit($event)"
      >
      </app-user-basic-info-form>
    }
    <app-error-alert
      title="{{ 'couldNotSubmitTheUsersProfile' | transloco }}"
      i18n-title="User profile submit error alert"
      [errors]="submitErrors"
    ></app-error-alert>
    @if (
      id !== "new" &&
      (authRepo.isInRole("Superadmin") || authRepo.isInRole("Administrator"))
    ) {
      <app-change-password-form
        (passwordSubmit)="onPasswordSubmit($event)"
        [isReset]="true"
      ></app-change-password-form>
    }
  </div>
</div>
